import { useHistory, useParams } from 'react-router'
import { Container } from './styles'
import React, { useEffect, useState } from 'react'
import api from '../../config/api'
import { Summary } from '../../components/Summary'
import { Button, Snackbar, Typography } from '@material-ui/core'
import DataTable from '../../components/DataTable'
import { ColDef } from '@material-ui/data-grid'
import { Alert } from '@material-ui/lab'


interface Productivity {
    id: number,
    cpf: number,
    year: Date,
    status: string,
    effective: boolean,
    total_brute: number,
    total_hire_cost: number,
    total_production_cost: number,
    total_liquid: number,
    user_id: number,
    created_at: Date,
    updated_at: Date
    fluid_process_id: number
    productivity_items: ProductivityItem[]
}

interface ProductivityItem {
    id: number,
    productivity_id: number,
    quantity?: number | null,
    production: number,
    area?: number | null,
    value: number,
    production_cost: number,
    hired: boolean,
    hire_production: number,
    total_brute: number,
    total_hire_cost: number,
    total_production_cost: number,
    total_liquid: number,
    agro_product_id: number
}


const columns: ColDef[] = [
    { field: 'id', headerName: 'ID', width: 60 },
    { field: 'agro_product', headerName: 'Empreendimento', width: 150 },
    { field: 'quantity', headerName: 'Quantidade', width: 120 },
    { field: 'production', headerName: 'Produção', width: 100 },
    { field: 'area', headerName: 'Área', width: 120 },
    { field: 'value', headerName: 'Valor', width: 120 },
    { field: 'production_cost', headerName: 'C. de Produção/ha', width: 160 },
    { field: 'hired', headerName: 'Arrendado', width: 100 },
    { field: 'hire_production', headerName: 'Produção arrendada', width: 120 },
    { field: 'total_brute', headerName: 'Valor bruto', width: 140 },
    { field: 'total_hire_cost', headerName: 'V. de arrendamento', width: 150 },
    { field: 'total_production_cost', headerName: 'V. de custo de produção', width: 150 },
    { field: 'total_liquid', headerName: 'V. líquido', width: 150 },
];

function ProductivityInfo() {
    //@ts-ignore
    const { id } = useParams()

    const [productivity, setProductivity] = useState<Productivity>()
    const [normalizedProductivityItems, setNormalizedProductionItems] = useState<any[]>([])
    const [branchDescription, setBranchDescription] = useState('')

    const [openSuccess, setOpenSuccess] = useState(false);
    const [openFailed, setOpenFailed] = useState(false);

    const history = useHistory()

    useEffect(() => {

        async function fetch() {
            const productivity = await api.get(`/productivitys/${id}`)

            setProductivity(productivity.data.productivity[0])
            const userRequest = await api.get(`/users/${productivity.data.productivity[0].user_id}`)


            const { branch_id } = userRequest.data.user[0]

            const requestBranch = await api.get(`/branchs/${branch_id}`)

            const requestAgroProducts = await api.get('/agroproducts')

            const { agroProducts } = requestAgroProducts.data

            setBranchDescription(requestBranch.data.branch.description)
            const auxNormalizedProductivity = productivity.data.productivity[0].productivity_items.map((item: ProductivityItem) => {

                const agroProduct = agroProducts.find((element: { id: number }) => item.agro_product_id === element.id)

                return {
                    ...item,
                    value: new Intl.NumberFormat('pt-BR', { currency: 'BRL', style: 'currency' }).format(item.value),
                    agro_product: agroProduct.description,
                    production_cost: new Intl.NumberFormat('pt-BR', { currency: 'BRL', style: 'currency' }).format(item.production_cost),
                    total_brute: new Intl.NumberFormat('pt-BR', { currency: 'BRL', style: 'currency' }).format(item.total_brute),
                    total_hire_cost: new Intl.NumberFormat('pt-BR', { currency: 'BRL', style: 'currency' }).format(item.total_hire_cost),
                    total_production_cost: new Intl.NumberFormat('pt-BR', { currency: 'BRL', style: 'currency' }).format(item.total_production_cost),
                    total_liquid: new Intl.NumberFormat('pt-BR', { currency: 'BRL', style: 'currency' }).format(item.total_liquid),
                    area: item.area ? `${item.area} ha` : undefined,
                    hired: item.hired ? 'Sim' : 'Não'

                }
            })

            setNormalizedProductionItems(auxNormalizedProductivity)
        }
        fetch()
    }, [])


    const handleCloseSuccess = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSuccess(false);
    };

    const handleCloseFailed = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenFailed(false);
    };

    async function handleConfirm() {
        try {

            const confirmedUpdated = await api.put(`/productivitys/${id}`, {
                status: 'ready'
            })
            setOpenSuccess(true)
            history.push('/productivitys')
        } catch (err) {
            setOpenFailed(true)
        }
    }

    async function handleUpdate() {
        try {
            const confirmedUpdated = await api.put(`/productivitys/${id}`, {
                status: 'editing'
            })
            setOpenSuccess(true)
            history.push('/productivitys')
        } catch (err) {
            setOpenFailed(true)
        }
    }

    return (
        <Container>
            <div style={{
                height: 250,
                backgroundColor: '#ebebeb',
                padding: '10px 20px 80px 20px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center'
            }} >
                <div>
                    <div style={{ marginBottom: 20 }}>
                        <Typography variant="h4" style={{ fontWeight: 600 }}>
                            CPF do associado: {productivity?.cpf}
                        </Typography>
                    </div>
                    <div>
                        <Typography variant="h4" style={{ fontWeight: 600 }}>
                            Processo Fluid: {productivity?.fluid_process_id ?? "Não Informado"}
                        </Typography>

                    </div>
                </div>
                <div>
                    <Typography variant="h4" style={{ fontWeight: 600 }}>
                        {branchDescription}
                    </Typography>
                </div>

            </div>
            {
                productivity &&
                <div style={{ margin: 20 }}>
                    <Summary brute={productivity.total_brute} cost={productivity.total_production_cost + productivity.total_hire_cost} liquid={productivity.total_liquid} />

                    <div style={{ display: 'flex', margin: '20px 0px' }}>
                        <Button variant="contained" onClick={handleConfirm} >
                            Confirmar Manualmente
                        </Button>
                        <Button variant="contained" style={{ marginLeft: 20 }} onClick={handleUpdate}>
                            Solicitar Ajuste Manualmente
                        </Button>
                    </div>

                    <DataTable columns={columns} rows={normalizedProductivityItems} />
                </div>
            }
            <Snackbar open={openSuccess} autoHideDuration={500} onClose={handleCloseSuccess}>
                <Alert onClose={handleCloseSuccess} severity="success">
                    Confirmado com sucesso!
                </Alert>
            </Snackbar>

            <Snackbar open={openFailed} autoHideDuration={2000} onClose={handleCloseFailed}>
                <Alert onClose={handleCloseFailed} severity="error">
                    Erro ao confirmar os dados
                </Alert>
            </Snackbar>
        </Container>
    )
}

export default ProductivityInfo